import z from 'zod';

export const success = z.object({
  success: z.boolean(),
});

export type Success = z.infer<typeof success>;
